module.exports = __webpack_public_path__ + "232f65f4.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_calendar_grey.png
// module id = 1342
// module chunks = 0 1